import * as React from 'react';

import LrDialog from 'components/LrDialog';

import { useState } from 'react';
import { createDBBQuoteForLocation } from 'services/quotes';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { TextInput } from '../../../Input';
import { currencyMask, numberMask } from 'helpers/masks';
import { DedBuyBackData } from 'types/underwriting.type';
import { currencyToNumber, formatDollar } from 'helpers/formatters';
import { COLORS } from '../../../../constants';

interface Props {
    onQuoteCreate: (buyBackData: DedBuyBackData) => void;
    onCancel: () => void;
    dbbDataItem: DedBuyBackData;
    uwReviewId: string;
}

const DBBCreateQuoteDialog: React.FunctionComponent<Props> = (props) => {
    const { dbbDataItem, onCancel, onQuoteCreate, uwReviewId } = props;

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSubmitEnabled, setIsSubmitEnabled] = useState<boolean>(true);
    const [dbbTargetDed, setDbbTargetDed] = useState(
        Number(dbbDataItem.buyBackDed) > 1
            ? formatDollar(Number(dbbDataItem.buyBackDed))
            : String(Number(dbbDataItem.buyBackDed) * 100)
    );
    const [targetType, setTargetType] = useState(Number(dbbDataItem.buyBackDed) > 1 ? 'DOLLAR' : 'PERCENT');
    const [error, setError] = useState<string>();

    const isTargetTypePercent = targetType === 'PERCENT';
    const createDBBQuote = async () => {
        setIsLoading(true);
        const data = await createDBBQuoteForLocation(dbbDataItem.locationId, uwReviewId, {
            buyBackDed: isTargetTypePercent ? Number(dbbTargetDed) / 100.0 : currencyToNumber(dbbTargetDed),
        }).catch((reason) => {
            setError(reason.message);
            return null;
        });
        setIsLoading(false);
        if (data != null) {
            setError(undefined);
            onQuoteCreate && onQuoteCreate(data);
        }
    };

    const handleDialogRadioChange = (event: any) => {
        if (event.target.value === 'DOLLAR') {
            setDbbTargetDed('10000');
        } else {
            setDbbTargetDed('1');
        }
        setTargetType(event.target.value);
    };

    return (
        <LrDialog
            isOpen
            isLoading={isLoading}
            width="750px"
            title="Create Ded Buy Back Quote"
            onSubmit={() => createDBBQuote()}
            onCancel={onCancel}
            submitButtonText="Submit"
            cancelButtonText="Cancel"
            isSubmitEnabled={isSubmitEnabled}
        >
            <Grid container>
                <Grid xs={7}>
                    <FormControl variant="standard">
                        <FormLabel>Deductible Type</FormLabel>
                        <RadioGroup name="target-type" onChange={handleDialogRadioChange} value={targetType}>
                            <FormControlLabel value="PERCENT" control={<Radio color="primary" />} label="%" />
                            <FormControlLabel value="DOLLAR" control={<Radio color="primary" />} label="$" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid xs={2}>
                    <TextInput
                        title={`Target Deductible ${isTargetTypePercent ? 'Percent' : 'Amount'}`}
                        name={`targetDuductible`}
                        placeholder="1"
                        value={dbbTargetDed}
                        onChange={(event) => {
                            setIsSubmitEnabled(!!event.target.value);
                            setDbbTargetDed(event.target.value);
                        }}
                        mask={isTargetTypePercent ? numberMask : currencyMask}
                        endAdornment={isTargetTypePercent ? '%' : ''}
                    />
                </Grid>
                <Grid xs={12}>
                    {error && (
                        <Grid xs={12}>
                            <Typography variant="body2" style={{ color: COLORS.ERROR }}>
                                {error}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </LrDialog>
    );
};

export default DBBCreateQuoteDialog;
